import { CurrencyCode } from '@shared/types/currency';

export const DEFAULT_CURRENCY_CODE = CurrencyCode.USD;
